import { render } from "./WhatsApp.vue?vue&type=template&id=8cc2f01c"
import script from "./WhatsApp.vue?vue&type=script&lang=js"
export * from "./WhatsApp.vue?vue&type=script&lang=js"
script.render = render

export default script